// extracted by mini-css-extract-plugin
export var bodySections = "_bm-8";
export var gray = "_bm-7";
export var green = "_bm-4";
export var iconContainer = "_bm-9";
export var iconWidgetContainer = "_bm-1";
export var phoneIcon = "_bm-2";
export var red = "_bm-5";
export var statusDot = "_bm-3";
export var widgetContainer = "_bm-0";
export var yellow = "_bm-6";